"use strict";
/*
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = {};
exports.FormContainer = {};
exports.FormSection = {};
exports.FormField = {};
exports.SectionHeader = {};
exports.SectionBody = {};
exports.SectionFooter = {};
exports.SectionFooterPrimaryContent = {};
exports.SectionFooterSecondaryContent = {};
exports.Input = {};
exports.Button = {};
exports.PhotoPickerButton = {};
exports.PhotoPlaceholder = {};
exports.SignInButton = {};
exports.SignInButtonIcon = {};
exports.SignInButtonContent = {};
exports.Strike = {};
exports.StrikeContent = {};
exports.ActionRow = {};
exports.FormRow = {};
exports.A = {};
exports.Hint = {};
exports.Radio = {};
exports.Label = {};
exports.InputLabel = {};
exports.AmazonSignInButton = {};
exports.FacebookSignInButton = {};
exports.GoogleSignInButton = {};
exports.OAuthSignInButton = {};
exports.Toast = {};
exports.NavBar = {};
exports.NavRight = {};
exports.Nav = {};
exports.NavItem = {};
exports.NavButton = {};
var AmplifyTheme = {
    container: exports.Container,
    formContainer: exports.FormContainer,
    formSection: exports.FormSection,
    formField: exports.FormField,
    sectionHeader: exports.SectionHeader,
    sectionBody: exports.SectionBody,
    sectionFooter: exports.SectionFooter,
    sectionFooterPrimaryContent: exports.SectionFooterPrimaryContent,
    sectionFooterSecondaryContent: exports.SectionFooterSecondaryContent,
    input: exports.Input,
    button: exports.Button,
    photoPickerButton: exports.PhotoPickerButton,
    photoPlaceholder: exports.PhotoPlaceholder,
    signInButton: exports.SignInButton,
    signInButtonIcon: exports.SignInButtonIcon,
    signInButtonContent: exports.SignInButtonContent,
    amazonSignInButton: exports.AmazonSignInButton,
    facebookSignInButton: exports.FacebookSignInButton,
    googleSignInButton: exports.GoogleSignInButton,
    oAuthSignInButton: exports.OAuthSignInButton,
    formRow: exports.FormRow,
    strike: exports.Strike,
    strikeContent: exports.StrikeContent,
    actionRow: exports.ActionRow,
    a: exports.A,
    hint: exports.Hint,
    radio: exports.Radio,
    label: exports.Label,
    inputLabel: exports.InputLabel,
    toast: exports.Toast,
    navBar: exports.NavBar,
    nav: exports.Nav,
    navRight: exports.NavRight,
    navItem: exports.NavItem,
    navButton: exports.NavButton,
};
exports.default = AmplifyTheme;
//# sourceMappingURL=Amplify-UI-Theme.js.map